import React, { Component } from 'react';
import './AddJob.css';
import { Grid, Row, Col, Alert } from 'react-bootstrap';
import { Form, FormGroup, FormControl, HelpBlock, ControlLabel } from 'react-bootstrap';
import MediaQuery from 'react-responsive';
import Button from '../../../components/UI/Button/Button';
import ConsoleLog from '../../../hoc/ConsoleLog/ConsoleLog';

/**
 * @desc Add jobTitle and client details with bullhorn Id
 * @param props
 * @return DOMElement
 */
const AddJob = (props) => {
  return (
    <Form inline className="job-form">
      <Row className="job-steps show-grid">
        <Col xs={12} sm={6} className="form-section job-details">
          <h2>Bullhorn Job Details</h2>
          <FormGroup 
            controlId="jobBH"
          >
          <p className="error-message">{(props.errorPosition.includes("jobBH")) ? "Please provide a valid Bullhorn Job ID to continue" : null}</p>
            <ControlLabel>Bullhorn Job ID:</ControlLabel>
            <FormControl
              className= {props.errorPosition.includes("jobBH") ?"invalid":""}
              type="text"
              placeholder="Enter Bullhorn Job ID"
              onChange={props.handleJobDetailsChange}
              required
              onKeyPress={props.handleKeyPressBHJobId}
            />
            <FormControl.Feedback />
          </FormGroup>

          <FormGroup
            controlId="jobTitle"
          >
            <p className="error-message">{(props.errorPosition.includes("jobTitle")) ? "Please provide Job Title to continue" : null}</p>
            <ControlLabel>Job Title:</ControlLabel>
            <FormControl
              className= {(props.errorPosition.includes("jobTitle")) ?"invalid":""}
              type="text"
              placeholder="Enter Job Title"
              onChange={props.handleJobDetailsChange}
              required
            />
            <FormControl.Feedback />

          </FormGroup>
          <FormGroup
            controlId="companyBHId"
          >
          <p className="error-message">{(props.errorPosition.includes("companyBHId")) ? "Please enter a valid Bullhorn Company ID to continue" :(props.errorPosition.includes("UnknownCompanyBHId"))?"Bullhorn Company ID does not exists" :null}</p>
            <ControlLabel>Bullhorn Company ID:</ControlLabel>
            <FormControl
              className={(props.errorPosition.includes("companyBHId")) ? "invalid" : ""}            
              type="text"
              placeholder="Enter Bullhorn Company ID"
              onChange={props.handleJobDetailsChange}
              required
              onKeyPress={props.handleKeyPressCmpyId}
            />
            <FormControl.Feedback />
          </FormGroup>
          <div className="div-confirm">
            <Button className="confirm"
              disabled={props.clientDetails ? true: false }
              onClick={ (event) => props.handleFetchClientDetails(event)} >
              Confirm
            </Button>
          </div>
          {/* Mobile View Section starts */}	
			    {/* <MediaQuery query="(max-device-width: 769px)">
            <div className="scroll-button-mobile-down">
              <div onclick={window.scrollBy(0, 200)} className="scroll-down-button"></div>
            </div>
          </MediaQuery> */}
          {/* Mobile View Section Ends */}
        </Col>
        <Col xs={12} sm={6} className="form-section client-details" id="myId">
          <h2>Bullhorn Client Details</h2>
          <div className="client-form-details">
            <ul>
              <li><label>Contact Name: </label>
                <span>{props.clientDetails.user_fname || props.clientDetails.user_lname?props.clientDetails.user_fname + " " + props.clientDetails.user_lname:""}</span>
              </li>
              <li><label>Contact ID: </label>
                <span>{props.clientDetails.user_bh_id}</span>
              </li>
              <li><label>Contact Email: </label>
                <span>{props.clientDetails.user_email}</span>
              </li>
              <li><label>Company Name: </label>
                <span>{props.clientDetails.company_name}</span>
              </li>
            </ul>
          </div>
          {/* Mobile View Section starts */}	
			    {/* <MediaQuery query="(max-device-width: 769px)">
            <div className="scroll-button-mobile-up">
              <div onclick={window.scrollBy(0, 0)} className="scroll-up-button"></div>
            </div>
          </MediaQuery> */}
          {/* Mobile View Section Ends */}
        </Col>
      </Row>
    </Form>
  );
}

export default AddJob;


// WEBPACK FOOTER //
// ./src/components/Recruiter/AddJob/AddJob.js